
export function setUsernameSurname(usernameSurname){
    return action("setUsernameSurname", usernameSurname)
}

export function email(email) {
    return action("email", email)
}


export function membershipNumber(number) {
    return action("membershipNumber", number)
}


export function deliveryType(type) {
    return action("deliveryType", type)
}

export function redirectTo(url, method, params) {
    return action("redirectTo", {
        url,
        method,
        params
    })
}

export function selectAmount(amount) {
    return action("selectAmount", amount)
}

export function selectIntervalAmount(amount) {
    return action("selectIntervalAmount", amount)
}


export function phoneNumberSelected(phoneNumber) {
    return action("phoneNumberSelected", phoneNumber)
}

export function selectOperatorByName(name) {
    return action("selectOperatorByName", name)
}

function action(type, payload) {
    return {
        type,
        payload
    }
}

